import styled, { css } from "styled-components";
import buildColor from "@tvg/atomic-ui/_static/ColorPalette";
import rainLayerUrl from "../../_static/images/rma-blue-texture.png";
import { fontNormal } from "../../_static/Typography";

export const OuterContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("blue", "900")};

  @media only screen and (max-width: 767px) {
    display: block;
  }

  @media only screen and (min-width: 768px) {
    &::before {
      content: "";
      background-image: url(${rainLayerUrl});
      background-repeat: no-repeat;
      background-position-x: center;
      background-size: 1280px auto;
      top: 0;
      left: 0;
      bottom: 450px;
      right: 0;
      position: absolute;
      z-index: 1;
    }
  }
`;

export const InnerContainer = styled.div`
  z-index: 2;
  background-color: ${buildColor("white", "100")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media only screen and (max-width: 767px) {
    min-height: 100vh;
  }

  @media only screen and (min-width: 768px) {
    width: 480px;
    min-height: 250px;
    border-radius: 2px;
    padding: 20px;
    align-self: center;
    margin-top: 124px;
    ${({ isOnfidoChecks }) =>
      isOnfidoChecks
        ? css`
            width: 510px;
            height: 598px;
            padding: 20px 52px 20px;
          `
        : ""}
  }
`;

export const BodyElement = styled.div`
  padding: 20px 24px 0;
  text-align: center;
  ${({ lastChild }) =>
    lastChild &&
    css`
      padding-bottom: 20px;
    `};
`;

export const StyledTitle = styled.h2`
  font-family: ${fontNormal};
  font-weight: 700;
  font-size: 16px;
  padding-bottom: 12px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and (max-width: 767px) {
    padding: 0 12px;
  }

  & > button {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const IconContainer = styled.div`
  position: relative;
  max-height: 70px;
  > svg:first-child {
    position: absolute;
    right: -13px;
    top: -18px;
  }
`;

export const TextBelowButtons = styled.p`
  padding-top: 12px;
  color: ${buildColor("grey", "800")};
  font-family: ${fontNormal};
  text-align: center;
`;
